import React from 'react';
import { Button, CircularProgress, Dialog, IconButton, Typography } from '@mui/material';
import { X } from 'react-feather';

// Дэд гарчиг: popup доторх бүлгүүдийг ялгах жижиг label
export const SectionLabel = ({ children }) => (
    <Typography
        variant="body12"
        className="text-gray-400 font-semibold uppercase tracking-wide mb-2 block"
    >
        {children}
    </Typography>
);

// Бүх "нэмэх/засах" popup-уудад ашиглагдах нэгдсэн орчин үеийн загвар:
// хөдөлгөөнгүй header (гарчиг + хаах товч) + гүйдэг content + хөдөлгөөнгүй footer.
const focusRing =
    'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400';

export const secondaryButtonClass = `py-1.5 px-3 rounded-lg font-semibold text-[11px] !text-gray-500 !bg-transparent hover:!bg-gray-100 transition-colors duration-150 normal-case ${focusRing}`;
export const primaryButtonClass = `py-1.5 px-3 rounded-lg font-semibold text-[11px] !text-white !bg-[#0f0f68] hover:!bg-[#040459] transition-colors duration-150 normal-case shadow-none ${focusRing}`;
export const dangerButtonClass = `py-1.5 px-3 rounded-lg font-semibold text-[11px] !text-white !bg-red-500 hover:!bg-red-600 transition-colors duration-150 normal-case shadow-none ${focusRing}`;

// Хадгалж байх үед товч дотроо жижиг spinner харуулж, дэлгэц дүүрэн блоклогч
// LoadingDialog-ийн оронд хөнгөн, тухайн үйлдэлд л хамаарах ачаалалын дохио өгнө.
export const SaveButton = ({ loading, disabled, children, className, ...rest }) => (
    <Button
        className={`${primaryButtonClass} !inline-flex !items-center !gap-2 ${className || ''}`}
        disabled={loading || disabled}
        {...rest}
    >
        {loading && <CircularProgress size={11} thickness={5} sx={{ color: '#fff' }} />}
        {children}
    </Button>
);

const CONFIRM_CLOSE_MSG = 'Гарахдаа итгэлтэй байна уу? Оруулсан мэдээлэл хадгалагдахгүй.';

// Хадгалаагүй өөрчлөлттэй үед popup-ыг хаахаас өмнө баталгаажуулна.
// Dialog-ийн X/backdrop/Escape-г ModalShell-ийн confirmClose prop даана,
// харин popup доторх өөрийн "Цуцлах" товчинд үүнийг шууд ашиглана.
export const confirmUnsavedClose = (dirty, onClose) => {
    if (dirty && !window.confirm(CONFIRM_CLOSE_MSG)) return;
    onClose?.();
};

const ModalShell = ({
    open,
    onClose,
    title,
    maxWidth = 'sm',
    actions,
    children,
    confirmClose,
}) => {
    const handleClose = (...args) => {
        if (confirmClose && !window.confirm(CONFIRM_CLOSE_MSG)) {
            return;
        }
        onClose?.(...args);
    };

    return (
        <Dialog
            open={!!open}
            onClose={onClose ? handleClose : undefined}
            fullWidth
            maxWidth={maxWidth}
            PaperProps={{
                sx: {
                    borderRadius: 2.5,
                    maxHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >
            <div className="flex items-center justify-between gap-4 px-5 py-3 border-b border-gray-100 shrink-0">
                <Typography variant="h16" className="text-gray-900 font-bold truncate">
                    {title}
                </Typography>
                {onClose && (
                    <IconButton
                        onClick={handleClose}
                        size="small"
                        aria-label="Хаах"
                        className={`!text-gray-400 hover:!text-gray-700 hover:!bg-gray-100 shrink-0 !p-1.5 ${focusRing}`}
                    >
                        <X size={13} />
                    </IconButton>
                )}
            </div>

            <div className="px-5 py-4 overflow-y-auto flex-1">{children}</div>

            {actions && (
                <div className="flex items-center justify-end gap-2 px-5 py-3 border-t border-gray-100 shrink-0">
                    {actions}
                </div>
            )}
        </Dialog>
    );
};

export default ModalShell;
